$(function () {
  if (!customElements.get('about-user-case')) {
    customElements.define(
      'about-user-case',
      class aboutUserCase extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.initCountUp();
          this.querySelectorAll('.marquee-track').forEach((track) => {
            this.initMarquee(track);
          });
        }
        initMarquee(track) {
          const direction = track.dataset.direction || 'left';
          const pauseType = track.dataset.pauseType || 'smooth';
          const totalTime = track.dataset.totalTime || 15;
          const itemsLength = track.children.length;
          const clone = track.innerHTML;
          track.insertAdjacentHTML('beforeend', clone);
          const computedGap = getComputedStyle(track);
          const trackGap = parseFloat(computedGap.gap);

          requestAnimationFrame(() => {
            const itemsWidth = Array.from(track.children)
              .slice(0, itemsLength)
              .reduce((total, item) => total + item.offsetWidth + trackGap, 0);

            const speed = parseFloat(track.dataset.speed) || 1;
            const duration = totalTime / speed;

            let startX, endX;
            if (direction === 'right') {
              startX = -itemsWidth;
              endX = 0;
            } else {
              startX = 0;
              endX = -itemsWidth;
            }

            gsap.set(track, { x: startX });

            const tl = gsap.to(track, {
              x: endX,
              duration: duration,
              ease: 'none',
              repeat: -1,
              onUpdate: function () {
                const currentX = this.targets()[0]._gsap.x;
                const absX = Math.abs(currentX);

                const shouldReset =
                  direction === 'right'
                    ? currentX >= -1 // 向右滚动即将到达0时
                    : absX >= itemsWidth - 1; // 向左滚动即将超过一组宽度时

                if (shouldReset) {
                  requestAnimationFrame(() => {
                    this.targets()[0].style.transition = 'none';
                    gsap.set(track, { x: startX });
                    this.restart();
                  });
                }
              },
            });

            track.addEventListener('mouseenter', () => {
              if (pauseType === 'immediate') {
                tl.pause();
              } else {
                gsap.to(tl, {
                  timeScale: 0,
                  duration: 1,
                  ease: 'power2.inOut',
                });
              }
            });

            track.addEventListener('mouseleave', () => {
              if (pauseType === 'immediate') {
                tl.resume();
              } else {
                gsap.to(tl, {
                  timeScale: 1,
                  duration: 1,
                  ease: 'power2.inOut',
                });
              }
            });
          });
        }
        initCountUp() {
          const numberDomList = this.querySelectorAll('.count');
          if (numberDomList.length) {
            numberDomList.forEach((item) => {
              const number = Number(item.dataset.number);
              new countUp.CountUp(item, number, {
                enableScrollSpy: true,
                scrollSpyOnce: true,
                scrollSpyDelay: 600,
                formattingFn: this._formatNumber,
              });
            });
          }
        }
        _formatNumber(value) {
          if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'M';
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + 'K';
          } else {
            return value.toString();
          }
        }
      }
    );
  }
});
